import { combineReducers } from 'redux'

import unknownWordsReducer from './unknown-words-reducer'

export default combineReducers({
  unknownWords: unknownWordsReducer,
})
